<template>
  <form
    ref="form"
    data-url="/accreditationtechnical/signatureDocument/signatureDocumentReport"
    :class="{ 'loading-opacity': preloader }"
    enctype="multipart/form-data"
  >
    <div class="row">
      <div class="col-12">
        <legend>
          <p class="text-primary">Documentación anterior</p>
        </legend>
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th scope="col" class="text-center">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="align-middle">Propuesta del equipo evaluador</td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTb(evalTest.file_evaluation)"
                >
                  <app-icon name="file" />
                  Ver
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <hr />
      <div class="col-12">
        <div class="card-body">
          <div class="form-group row mb-0">
            <label class="col-sm-2">
              {{ $t("Documentos  de designación Equipo Evaluador") }}
              <br />
              <small class="text-center text-danger" v-if="!inputs.proforma">
                <b>Tamaño máximo de cada archivo 8MB</b>
              </small>
            </label>
            <div class="col-sm-7">
              <app-input type="dropzone" v-model="dropzone_files" />
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col">Nombre del documento</th>
                <th scope="col" class="text-center">Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(
                  value, key
                ) in inputs.signature_evaluation_team_document"
                :key="key"
              >
                <td class="align-middle">
                  <small class="text-primary"
                    >{{ (value.path.split('/'))[(value.path.split('/')).length - 1] }}</small
                  >
                </td>
                <td class="align-middle text-center">
                  <div class="mt-2">
                    <button
                      type="submit"
                      class="btn btn-success btn-sm"
                      @click.prevent="openTab(value.full_url)"
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                    <!-- <button
                      type="submit"
                      class="btn btn-danger btn-sm"
                      @click.prevent="openDeleteModal(value.path)"
                    >
                      <app-icon name="trash-2" />
                      {{ $t("delete") }}
                    </button> -->
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="row" style="text-align: center">
      <div class="col-12 mt-3">
        <div class="mt-2">
          <button
            type="submit"
            class="btn btn-primary mr-2"
            @click.prevent="submit"
          >
            {{ $t("save") }}
          </button>
          <button
            v-if="contador > 0"
            type="submit"
            class="btn btn-danger mr-2"
            @click.prevent="deleteLast"
          >
            <app-icon name="trash-2" />
            {{ $t("Eliminar") }}
          </button>
        </div>
      </div>
    </div>

    <app-confirmation-modal
      v-if="deleteModal"
      modal-id="delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea eliminar este archivo?"
    />
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../../apiUrl";
export default {
  mixins: [FormMixin],

  data() {
    return {
      preloader: false,
      inputs: {},
      deleteModal: false,
      selected: "",
      dropzone_files: [],
      contador: 0,
      request: {},
    };
  },

  computed: {
    evalTest() {
      return this.$store.state.evaluatorReview.evalTest
        ? this.$store.state.evaluatorReview.evalTest
        : {};
    },
  },

  watch: {
    "$store.state.evaluatorReview.evalTest": function () {
      this.loadForm();
    },
    dropzone_files: function (items) {
      this.loadForm2();
    },
  },

  created() {
    this.loadForm();
    this.show();
    // this.loadForm2();
  },

  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    openTab(full_url) {
      const w = window.open(full_url, "_blank");
      w.focus();
    },

    openTb(file) {
      const w = window.open(file.full_url, "_blank");
      w.focus();
    },
    submit() {
      if (this.dropzone_files.length > 0 && this.validateFileSize() > 0) {
        this.$toastr.e("El tamaño maximo permitido de cada archivo es de 8MB");
        return;
      }

      let formData = new FormData();
      for (let index = 0; index < this.dropzone_files.length; index++) {
        (this.contador = this.contador + 1),
          formData.append("id[]", this.contador);
        formData.append(
          "evalTestId",
          this.$store.state.evaluatorReview.evalTest.id
        );
        formData.append(`file_${this.contador}`, this.dropzone_files[index]);
      }

      this.save(formData);
    },

    afterSuccess(res) {
      this.loadForm2();
      this.dropzone_files = null;
      this.$store.state.evaluatorReview.evalTest = data;
      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      // console.log(res);
      // this.$toastr.e(res.data.message);
    },

    openDeleteModal(path) {
      localStorage.setItem("path_delete", path);
      this.selected = path;
      this.deleteModal = true;
    },

    deleteLast() {
      localStorage.setItem(
        "path_delete",
        this.inputs.signature_evaluation_team_document[this.contador - 1].path
      );
      this.selected =
        this.inputs.signature_evaluation_team_document[this.contador - 1].path;
      this.deleteModal = true;
    },

    confirmed() {
      this.request["url"] = localStorage.getItem("path_delete");
      this.request["evalTestId"] =
        this.$store.state.evaluatorReview.evalTest.id;
      var url = `${actions.TECHNICAL_ANALYSIS_REPORT}/signatureDocument/signatureDocumentReport/deleteFile`;
      axios.post(url, this.request).then((response) => {
        this.$toastr.s(this.$t("updated_success"));
        this.loadForm2();
      });
    },

    cancelled() {
      this.deleteModal = false;
    },

    loadForm() {
      if (this.$store.state.evaluatorReview.evalTest) {
        this.inputs = {
          evalTestId: this.$store.state.evaluatorReview.evalTest.id,
          signature_evaluation_team_document:
            this.$store.state.evaluatorReview.evalTest
              .signature_evaluation_team_document,
        };
        if (this.inputs.signature_evaluation_team_document) {
          this.contador = this.inputs.signature_evaluation_team_document.length;
        } else {
          this.contador = 0;
        }
      }
    },
    loadForm2() {
      this.inputs = {
        evalTestId: this.$store.state.evaluatorReview.evalTest.id,
        signature_evaluation_team_document:
          this.$store.state.evaluatorReview.evalTest
            .signature_evaluation_team_document,
      };
      this.show();
    },

    show() {
      var url = `${actions.TECHNICAL_ANALYSIS_REPORT}/signatureDocument/signatureDocumentReport/show/${this.$store.state.evaluatorReview.evalTest.id}`;
      axios.get(url).then((response) => {
        this.inputs = {
          evalTestId: this.$store.state.evaluatorReview.evalTest.id,
          signature_evaluation_team_document:
            response.data.signature_evaluation_team_document,
        };
        if (this.inputs.signature_evaluation_team_document) {
          this.contador = this.inputs.signature_evaluation_team_document.length;
        } else {
          this.contador = 0;
        }
      });
    },

    validateFileSize() {
      return this.dropzone_files.filter((file) => {
        if (file.size > 8000000) {
          return file;
        }
      }).length;
    },
  },
};
</script>